// styles.js
// Shared styles for ListingDetails components

import { COLORS } from '../../constants';

export const styles = {
  container: {
    maxWidth: 1000,
    margin: '40px auto',
    padding: 24
  },

  contentLayout: {
    display: 'flex',
    gap: 40
  },

  imageSection: {
    flex: '0 0 400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },

  infoSection: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start'
  },

  imageContainer: {
    position: 'relative',
    width: 360,
    height: 360,
    marginBottom: 16
  },

  mainImage: {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    borderRadius: 8,
    border: '1px solid #ccc',
    background: '#fafafa'
  },

  navigationButton: {
    position: 'absolute',
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'rgba(255,255,255,0.7)',
    border: 'none',
    borderRadius: '50%',
    width: 32,
    height: 32,
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: 18
  },

  prevButton: {
    left: 8
  },

  nextButton: {
    right: 8
  },

  thumbnailContainer: {
    display: 'flex',
    gap: 8,
    overflowX: 'auto'
  },

  thumbnail: {
    width: 60,
    height: 60,
    objectFit: 'cover',
    borderRadius: 4,
    cursor: 'pointer'
  },

  thumbnailActive: {
    border: `2px solid ${COLORS.secondary}`,
    boxShadow: `0 0 4px ${COLORS.secondary}`
  },

  thumbnailInactive: {
    border: '1px solid #ccc'
  },

  noImagesPlaceholder: {
    width: 360,
    height: 360,
    background: '#eee',
    borderRadius: 8,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  title: {
    marginBottom: 8
  },

  price: {
    fontSize: 28,
    color: COLORS.secondary,
    marginBottom: 16
  },

  categoryLabel: {
    fontWeight: 500
  },

  category: {
    marginBottom: 16
  },

  descriptionLabel: {
    fontWeight: 500
  },

  description: {
    marginTop: 4,
    color: '#444'
  },

  descriptionContainer: {
    marginBottom: 24
  },

  sellerContainer: {
    marginBottom: 24,
    background: '#f8f8f8',
    padding: 12,
    borderRadius: 6
  },

  sellerName: {
    fontWeight: 500
  },

  sellerEmail: {
    fontSize: 13
  },

  actionButtons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    alignItems: 'flex-start'
  },

  messageButton: {
    alignSelf: 'flex-start',
    background: COLORS.primary,
    color: '#fff',
    border: 'none',
    borderRadius: 6,
    padding: '10px 24px',
    fontWeight: 600,
    fontSize: 16,
    cursor: 'pointer'
  },

  ownerMessage: {
    background: 'rgba(206, 17, 38, 0.1)',
    border: '2px solid rgba(206, 17, 38, 0.2)',
    borderRadius: '12px',
    padding: '16px 20px',
    textAlign: 'center',
    marginTop: '16px'
  },

  ownerText: {
    color: COLORS.primary,
    fontWeight: '600',
    fontSize: '16px',
    margin: '0 0 8px 0'
  },

  ownerSubtext: {
    color: COLORS.text.secondary,
    fontSize: '14px',
    margin: '0'
  },

  soldBanner: {
    background: 'linear-gradient(135deg, #4caf50, #66bb6a)',
    color: 'white',
    padding: '12px 20px',
    borderRadius: '10px',
    fontWeight: '600',
    textAlign: 'center',
    marginTop: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px'
  },

  loadingContainer: {
    textAlign: 'center',
    padding: '50px'
  },

  notFoundContainer: {
    textAlign: 'center',
    padding: '50px'
  },

  recommendationsSection: {
    marginTop: 48
  },

  recommendationsTitle: {
    marginBottom: 16
  },

  recommendationsGrid: {
    display: 'flex',
    gap: 24,
    flexWrap: 'wrap',
    marginTop: 16
  },

  recommendationCard: {
    width: 220
  },

  recommendationImage: {
    width: 220,
    height: 140,
    background: '#eee',
    borderRadius: 8,
    marginBottom: 8
  },

  recommendationTitle: {
    fontWeight: 500
  },

  recommendationCategory: {
    color: '#888',
    fontSize: 13
  }
};